module.exports = __webpack_public_path__ + "static/media/electrical.3b75000c.jpg";